import React, { useState } from "react";
import styled from "styled-components";
import { Carousel, Modal } from "antd";

interface MediaFile {
  url: string;
  type: string;
}

interface MediaContentProps {
  files: MediaFile[];
}

export const MediaContent: React.FC<MediaContentProps> = ({ files }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  if (files.length === 0) return null;
  if (files.length === 1) {
    const file = files[0];
    return file.type.startsWith("image/") ? (
      <>
        <PostImage
          src={file.url}
          alt="post"
          onClick={() => {
            setPreviewIndex(0);
            // setPreviewVisible(true);
          }}
          style={{ cursor: "pointer" }}
        />
        <Modal
          open={previewVisible}
          onCancel={() => setPreviewVisible(false)}
          footer={null}
          width="50svw"
          centered
          wrapClassName="social-modal"
          style={{ padding: "20px 0" }}
          closeIcon={null}
        >
          <PreviewModalContent>
            <PreviewModalHeader>
              <h3>Image Preview</h3>
              <CloseButton onClick={() => setPreviewVisible(false)}>
                ×
              </CloseButton>
            </PreviewModalHeader>
            <PreviewModalBody>
              <img
                src={file.url}
                alt="preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </PreviewModalBody>
          </PreviewModalContent>
        </Modal>
      </>
    ) : (
      <PostVideo src={file.url} controls />
    );
  }

  return (
    <>
      <CarouselWrapper>
        <Carousel
          dots={true}
          draggable={true}
          swipeToSlide={true}
          infinite={false}
          arrows={files.length > 1}
        >
          {files.map((file, index) => (
            <div key={index} style={{ borderRadius: "12px" }}>
              {file.type.startsWith("image/") ? (
                <PostImage
                  src={file.url}
                  alt={`post-${index}`}
                  onClick={() => {
                    setPreviewIndex(index);
                    // setPreviewVisible(true);
                  }}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <PostVideo src={file.url} controls />
              )}
            </div>
          ))}
        </Carousel>
      </CarouselWrapper>

      <Modal
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        footer={null}
        width="50svw"
        centered
        wrapClassName="social-modal"
        style={{ padding: "20px 0" }}
        closeIcon={null}
      >
        <PreviewModalContent>
          <PreviewModalHeader>
            <h3>Image Preview</h3>
            <CloseButton onClick={() => setPreviewVisible(false)}>
              ×
            </CloseButton>
          </PreviewModalHeader>
          <PreviewModalBody>
            <img
              src={files[previewIndex].url}
              alt="preview"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </PreviewModalBody>
        </PreviewModalContent>
      </Modal>
    </>
  );
};

const PostImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const PostVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 100%;

  div {
    height: 100% !important;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }
`;

const PreviewModalContent = styled.div`
  background: #282828;
  border-radius: 24px;
  overflow: hidden;
  max-width: 90vw;
  height: 80svh;
  display: flex;
  flex-direction: column;
`;

const PreviewModalHeader = styled.div`
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    color: #fff;
    margin: 0;
    font-size: 1.2rem;
  }
`;

const PreviewModalBody = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1a1a1a;
  box-sizing: border-box;
  height: calc(80svh - 65px);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #bdbdbd;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;
